import charityRepo from "./charityRepo"
import functionRepository from "./functionRepository";
const repositories = {
  charity:charityRepo,
  functions:functionRepository
};
export const RepositoryFactory = {
  get: (name) => repositories[name],
};
